import React from "react";
import experienceData from "../exports/Experience";
import "../styles/ExperienceTimeline.scss";

function WorkExperience() {
  return (
    <>
      <header className="relative">
        <h1>Work Experience :</h1>
      </header>

      <div className="h-screen w-full flex flex-col">
        <div id="timeline" className="flex-1 p-4">
          <ul className="line h-4/5 space-y-6 md:space-y-8">
            {experienceData.map((experience, index) => (
              <li
                key={index}
                className="flex flex-col md:flex-row md:space-x-4 items-start md:items-center no-scrollify"
              >
                <div className="cont bg-transparent p-4 rounded-lg shadow-md w-full md:w-1/2">
                  <h4 className="md:text-lg text-xs font-semibold">
                    {experience.role.split("\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </h4>
                  <p className="flex flex-wrap mt-1 text-yellow-50">
                    {experience.description.split("\n").map((line, index) => (
                      <span
                        key={index}
                        style={{
                          textIndent: line.trim().startsWith("-")
                            ? "-0.5em"
                            : "0",
                          paddingLeft: line.trim().startsWith("-")
                            ? "0"
                            : "3em",
                          display: "block",
                          marginBottom: "0.5em", // Adds space below each line
                        }}
                      >
                        {line.trim()}
                      </span>
                    ))}
                  </p>
                  <div className="mt-2 text-sm text-gray-500">
                    <time className="flex flex-wrap">{experience.date}</time>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default WorkExperience;
